import type { TokenBucket } from '~/interfaces/TokenBucket'

// Refills continuously: `capacity` tokens per `windowMs`, never above `capacity`.
export function createTokenBucket(
  capacity: number,
  windowMs: number,
  now: () => number = () => Date.now()
): TokenBucket {
  let tokens = capacity
  let updatedAt = now()

  const refill = (): void => {
    const current = Math.max(updatedAt, now())
    tokens = Math.min(capacity, tokens + (Math.max(0, current - updatedAt) * capacity) / windowMs)
    updatedAt = current
  }

  return {
    take: (requested) => {
      refill()
      const granted = Math.max(0, Math.min(requested, Math.floor(tokens)))
      tokens -= granted
      return granted
    },
    available: () => {
      refill()
      return tokens
    }
  }
}
